/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grand_Same_Skate_RadiateInputs */

const fr_grand_same_skate_radiate = /** @type {(inputs: Grand_Same_Skate_RadiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu as terminé cette section, coche la et enregistre.`)
};

/**

* @param {Grand_Same_Skate_RadiateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const grand_same_skate_radiate = /** @type {((inputs?: Grand_Same_Skate_RadiateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grand_Same_Skate_RadiateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_grand_same_skate_radiate(inputs)
});